import { FieldErrors } from '@weezevent/nacre';
import React from 'react';
import PropTypes from 'prop-types';

export const FieldErrorMessage = ({ error }) => {
    const hasError = !!error;
    const { message: errorMessage } = error || {};

    return hasError ? <FieldErrors errors={[errorMessage]} /> : null;
};

FieldErrorMessage.propTypes = {
    error: PropTypes.shape({
        message: PropTypes.string
    })
};
